import { FC } from "react";
import { Link } from "react-router-dom";
import { withPage } from "../../components/Page";
import { InfoCallout } from "../../components/InfoCallout";
import { NoticeBanner } from "../../components/NoticeBanner";
import { ProminentAlert } from "../../components/ProminentAlert";
import styles from "./MoreInfo.module.scss";

const MoreInfo: FC = () => {
  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <span className={styles.eyebrow}>PULSE DEMO ENVIRONMENT</span>
        <h1 className={styles.title}>This would lead to more information</h1>
        <p className={styles.subtitle}>
          You have clicked a demonstrative link in the Pulse prototype.
        </p>
      </div>

      <ProminentAlert />

      <InfoCallout variant="warning" title="Demonstration Placeholder">
        As explained in the <Link to="/demo">Demo Guide</Link> and on the
        homepage, many links throughout this prototype are illustrative and
        placed for demonstrative purposes only to show how the interface is
        structured.
      </InfoCallout>

      <div className={styles.card}>
        <h2>What this means</h2>
        <p>
          In a fully realized production deployment of Pulse, selecting this
          item would open the corresponding technical documentation, asset
          record, drawing sheet, or maintenance report.
        </p>
        <p>
          For this interactive concept demo, only key areas (such as the{" "}
          <Link to="/search">Search engine</Link>,{" "}
          <Link to="/design-criteria/mechanical">
            Mechanical Design Criteria
          </Link>
          , <Link to="/drawings">Drawings</Link>, and{" "}
          <Link to="/asset-data/ahu-003">AHU-003 asset record</Link> have fully
          functioning data and document connections.
        </p>
      </div>

      <NoticeBanner>
        <strong>This is a customisable demo platform:</strong> The structure of
        the app would be customised to fit the data that works for you. It
        demonstrates how Pulse serves as a comprehensive building information
        platform, leveraging advancements in technology such as AI, smarter
        search and optional QR code access — making building information faster
        to find, easier to use and more accessible in the office or on site.
      </NoticeBanner>

      <div className={styles.actions}>
        <Link to="/" className={styles.primaryButton}>
          Demo Home
        </Link>
        <a
          href="https://pulseom.co.uk"
          className={styles.secondaryButton}
          target="_blank"
          rel="noopener noreferrer"
        >
          Return to pulseom.co.uk
        </a>
      </div>
    </div>
  );
};

export default withPage(MoreInfo)({
  meta: {
    title: "More Information · Pulse Demo",
    description:
      "Informational placeholder page for demonstrative links in the Pulse prototype.",
  },
  breadcrumbs: [{ label: "Pulse", href: "/" }, { label: "More Information" }],
});
